module.exports = __webpack_public_path__ + "img/pic-empty.9c99419d.png";